import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import Calculator from "../../components/Calculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';

import { Textfit } from 'react-textfit';

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

//used for smart allocation -refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function RandomChar() {
  var result = '';
  var characters = 'abcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  result = characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
}

//Generates a question from a default question
function GenQuestion(q) {
  console.log(q);
  //All the shared variables
  let questionAnswers = [];
  var questionText = "";
  var correctAnswer = "";
  let wrongAnswers = [];
  //First question type
  if (q.question_key === "AlgebraQ1") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 6 + 5);
    const number2 = Math.floor(Math.random() * (number1 - 1) + 1);
    const theAnswer = number1 - number2;
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', theAnswer).replace('^', number1);
    correctAnswer = number2;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Second Question type
  if (q.question_key === "AlgebraQ2") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 4 + 1);
    const number2 = Math.floor(Math.random() * (10 - number1) + (number1 + 1));
    const number3 = number1 + number2;
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', number1).replace('^', number2);
    correctAnswer = number3;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Third Question type
  if (q.question_key === "AlgebraQ3") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = number1 * number2;
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', number1).replace('^', number3);
    correctAnswer = number2;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Forth Question type
  if (q.question_key === "AlgebraQ4") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = Math.floor(Math.random() * 5 + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('n&', number2 + theChar).replace('£', number1).replace('*', number3);
    correctAnswer = (number1 * number2) + number3;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Fifth Question type
  if (q.question_key === "AlgebraQ5") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = Math.floor(Math.random() * 5 + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('n&', number2 + theChar).replace('£', number1).replace('*', number3);
    correctAnswer = (number1 * number2) - number3;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Sixth Question type
  if (q.question_key === "AlgebraQ6") {
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 4 + 2);
    var sequence = ' ';
    for (var j = 0; j < 4; j++) {
      sequence += (number1 + (number2 * j)) + ', ';
    }
    sequence += '%';
    sequence = sequence.replace(', %', '...');
    questionText = q.question_line_1 + sequence;
    correctAnswer = "Add " + number2;
    let randAnswers = [];
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = number2 + Math.floor(Math.random() * 10 - 5);
      while (randAnswers.includes(randAns) || randAns == number2)
        randAns = number2 + Math.floor(Math.random() * 10 - 5);
      randAnswers.push(randAns);
      wrongAnswers.push("Add " + randAns);
    }
  }
  //Seventh Question type
  if (q.question_key === "AlgebraQ7") {
    const number1 = Math.floor(Math.random() * 8 + 3);
    const number2 = Math.floor(Math.random() * (number1 - 1) + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('£', number1)
    correctAnswer = number2 + " and " + (number1 - number2);
    wrongAnswers.push((number2 - 1) + " and " + (number1 - number2));
    wrongAnswers.push(number2 + " and " + (number1 - number2 + 1));
    wrongAnswers.push((number2 + 1) + " and " + (number1 - number2 + 1));
  }
  //Eighth Question type
  if (q.question_key === "AlgebraQ8") {
    const theChar = RandomChar();
    var otherChar = RandomChar();
    while (theChar == otherChar)
      otherChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = Math.floor(Math.random() * 4 + 2);
    const number4 = Math.floor(Math.random() * 4 + 2);
    var ansNum = (number1 * number3) + (number2 * number4);
    questionText = q.question_line_1;
    questionText = questionText.replace('£1&1', number1 + theChar).replace('£2&2', number2 + otherChar).replace('^', ansNum);
    correctAnswer = theChar + " = " + number3 + ", " + otherChar + " = " + number4;
    wrongAnswers.push(theChar + " = " + (number3 + 1) + ", " + otherChar + " = " + number4);
    wrongAnswers.push(theChar + " = " + number3 + ", " + otherChar + " = " + (number4 - 1));
    wrongAnswers.push(theChar + " = " + (number3 - 1) + ", " + otherChar + " = " + (number4 + 1));
  }
  //Ninth Question type
  if (q.question_key === "AlgebraQ9") {
    const theChar = RandomChar();
    var otherChar = RandomChar();
    while (theChar == otherChar)
      otherChar = RandomChar();
    const number1 = Math.floor(Math.random() * 4 + 2);
    questionText = q.question_line_1;
    questionText = questionText.replace('£L1', number1 + theChar).replace('L2', otherChar);
    correctAnswer = number1 + otherChar + theChar;
    wrongAnswers.push((number1 + 1) + otherChar + theChar);
    wrongAnswers.push((number1) + otherChar + otherChar);
    wrongAnswers.push((number1) + theChar + theChar);
  }
  //Tenth Question type
  if (q.question_key === "AlgebraQ10") {
    const theChar = RandomChar();
    var otherChar = RandomChar();
    while (theChar == otherChar)
      otherChar = RandomChar();
    const number1 = Math.floor(Math.random() * 4 + 2);
    var number2 = Math.floor(Math.random() * 4 + 2);
    while (number1 == number2)
      number2 = Math.floor(Math.random() * 4 + 2);
    questionText = q.question_line_1;
    questionText = questionText.replace('£1&1', number1 + theChar).replace('£2&2', number2 + otherChar);
    correctAnswer = number2 + otherChar + " + " + number1 + theChar;
    wrongAnswers.push(number2 + theChar + " + " + number1 + otherChar);
    wrongAnswers.push(number2 + otherChar + " + " + number2 + theChar);
    wrongAnswers.push(number1 + otherChar + " + " + number2 + otherChar);
  }
  //Eleventh Question type
  if (q.question_key === "AlgebraQ11") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 3 + 2);
    var mod = 'double';
    if (number1 == 3)
      mod = 'triple';
    if (number1 == 4)
      mod = 'quadruple';
    const number2 = Math.floor(Math.random() * 10 + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('*', mod).replace('&', theChar).replace('£', number2);
    correctAnswer = number1 + theChar + " + " + number2;
    wrongAnswers.push((number1 + 1) + theChar + " + " + number2);
    wrongAnswers.push(number1 + theChar + " + " + (number2 + 1));
    wrongAnswers.push((number1 + 1) + theChar + " + " + (number2 + 1));
  }
  //Add the correct answer
  questionAnswers.push({
    correct: true,
    value: correctAnswer
  });
  //Add the wrong answers
  for (var j = 0; j < 3; j++) {
    questionAnswers.push({ correct: false, value: wrongAnswers[j] });
  }

  shuffleArray(questionAnswers);

  console.log(questionText + ": " + correctAnswer);
  let questionObj = {
    question: questionText,
    answers: questionAnswers,
    correct: correctAnswer,
    topic_id: q.topic_id
  };

  return questionObj;
}

export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const[showColouredFeedback, setColouredFeedback] = useState(false);
    const [waitTime, setWaitTime] = useState(-10);

  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 60;
  }
  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

    //if question counter is higher than 3 then reset -refeed
    if (questionCounter > 3) {
        questionCounter = 0;
    }

    //Sets the question to a new one
    function newQuestion() {

        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);

        //Debugging
        /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currQuestion.question);
        console.log("tst: Counter: " + questionCounter);
        */

        //get refeed question
        var loop = true;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions[refeedQuestions.length - 1];
            loop = false;
        }
        else {
            //if current quesiton is same as the previous question then reloop -refeed 
            while (loop) {
                if (currQuestion.question.toString() === lastQuestion.toString()) {
                    console.log("tst: I have looped!");
                    currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);
                }
                else {
                    console.log("tst: Good to go!");
                    loop = false;
                    break;
                }
            }
        }
        setCurrentQuestion(currQuestion)
    }

    //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
    function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
    }

  
  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  //Called on click
    async function checkResult(value, callback) {

     //set the current question to the last question -refeed
    questionCounter = questionCounter + 1;
    lastQuestion = currQuestion.question;

    var isCorrect = true;
    if (value) {
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
              refeedQuestions.pop();
              repeating = false;
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
      };
      setNoFeedback([...nofeedback, result]);

        newQuestion();
      }
      //incorrect answer
      else {
          isCorrect = false;
          questionCounter = 0;
          //push question to refeed if user gets it wrong - refeed
          refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);


  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      var sample = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);
      currQuestion = sample;
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
    }
  }, [status]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.gameData.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/"+imageName)
        return (require("../../assets/"+imageName))
}

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
          onBack={() => {
              props.onBack();
              Reset();
          }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
            setIncorrectQuestions([]);
            Reset();
        }}
      >
        <div style={{  backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
        <Scale scaleTo={1920}>
          <Body>
            <div style={{ width: "80%" }}>
              {currQuestion !== undefined ? (


                <Container>
                  <div style={{ display: "flex", flexDirection: "row" }}>


                
                    <Question
                      type="text"
                      disabled
                      javaScriptEnabled={true}
                      //I don't know if this does anything
                      value={
                        currQuestion.question !== undefined
                          ? <div dangerouslySetInnerHTML={((currQuestion.question.replace("$", "?")))} />
                          : ""
                      }
                    >
                        <Textfit mode="multi" max="99" style={{ height: "100%" }}> 
                        <div dangerouslySetInnerHTML={{ __html: (currQuestion.question) }}></div>
                        </Textfit>
                    </Question>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  >
                    {showColouredFeedback == false && currQuestion.answers !== undefined &&
                      currQuestion.answers.map(answer => (
                        <Button
                          value={<div dangerouslySetInnerHTML={answer.value} />}
                          style={{ flex: 1, margin: "20px" }}
                          onClick={() => checkResult(answer, true)}
                        >
                          <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                        </Button>
                      ))}

                    {showColouredFeedback == true && currQuestion.answers !== undefined &&
                      currQuestion.answers.map(answer => (
                        <Button
                          value={<div dangerouslySetInnerHTML={answer.value} />}
                          style={{ flex: 1, margin: "20px" , ...(answer.value == currQuestion.correct ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                        >
                          <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                        </Button>
                      ))}
                  </div>
                </Container>

              ) : <h1>help</h1>}
            </div>
            <Combo>
              <span style={{ fontSize: "50px" }}>{combo}</span>
              <span style={{ fontSize: "20px" }}>COMBO</span>
            </Combo>
          </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("${props => props.gameBackground}");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
        background: #FFF;
        user-select: none;
        width: 150%;
        height: 120px;
        line-height: 90px;
        font-size: 4em;
        margin: 15px 25px;
        text-align: center;
        font-weight: 600;
        border: none;
        border-radius: 10px;
      `;

const Button = styled.div`
        text-align: center;
        width: 10%;
        height: 150px;
        line-height: 100px;
        font-size: 4em;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        padding: 0.5em;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;